<template>
    <div class="monitors_ paychannel">
        <div class="whitelistbox" style="padding-bottom:32px;">
                <el-table
                    :data="logexportlist"
                    border
                    stripe
                       
                    style="width: 100%">
                     <el-table-column
                        prop="ReportName"
                        label="导出项目"
                        width="200"
                        align="center"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="ExportTime"
                        label="开始时间"
                        width="200"
                        align="center"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="ExportEndTime"
                        label="结束时间"
                        width="200"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span>{{scope.row.ExportEndTime==null?"":scope.row.ExportEndTime}}</span>
                        </template>
                    </el-table-column>
                    
                     <el-table-column
                        prop="FailReason"
                        label="失败原因"
                        align="center"
                        >
                    </el-table-column>
                     <el-table-column
                        prop="ExportStatusDesc"
                        label="状态"
                        align="center"
                        >
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                            <el-button @click="gotodown(scope.row)"
                              :disabled="scope.row.ExportStatus!=1"
                              type="warning"
                              size="small">下载</el-button>
                              <el-button type="danger" size="small"  @click="OpenRemoveReportExportCacheDialog(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
        <!-- 删除下载列表 -->
        <el-dialog
            title="提示"
            v-loading="ifadd"
            :visible.sync="BeforeDeleteDialogVisible"
            width="30%">
            <span>确认删除此条下载文件？</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="BeforeDeleteDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="RemoveReportExportCache()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>



export default {
  name: "whiteList",

  data() {
    return {

        BeforeDeleteDialogVisible:false,
        logexportlist:[],
        deleteidcode:"",
        ifadd:false
    };
  },
  created() {
 
    this.$store.state.loaction = "/selects/exportdown";
    this.QryPayChannelWhiteList();

    
  },
  methods: {

   
      //获取下载列表
      QryPayChannelWhiteList(){

        var url = "/report/GetReportExportCache";
        var post = '';
        this.$loginapi.post(url, post, response => {

            if (response.Ret == 0) {

                this.logexportlist=response.Data
              
            } else {

                this.$alert(response.Msg, {});
            }
        }); 
          
      },
      //打开删除
      OpenRemoveReportExportCacheDialog(item){


          this.deleteidcode=item.Mac;
          this.BeforeDeleteDialogVisible=true;
      },
      //删除下载列表
      RemoveReportExportCache(){

        
        this.ifadd=true;
        var postData=this.deleteidcode;
        
        var url="/report/RemoveReportExportCache";

        this.$loginapi.post(url, [postData], response => {

        if (response.Ret == 0) {

           this.$message.success("删除成功");

           this.ifadd=false;
           this.BeforeDeleteDialogVisible=false;

           this.QryPayChannelWhiteList();
         
        } else {
          
           this.$alert(response.Msg, {});
        }
      });
    },
      gotodown(item){

        window.open(item.Url,"_blank")
      }
        
  }
};
</script>

<style lang="less">


.searchbox{

    padding: 10px 0 10px 30px;
    border-bottom: 1px solid #e5e5e5;
}

    .addwhitelist{

        display: flex;
        padding-top: 0px;
        
        .lefttablebox{

            width: 45%;
            .operationbtn{

                margin: 20px 0;
            }
        }
        .bindbox{

            width: 10%;
            .allbind{

                width: 35px;
                height: 120px;
                padding: 10px;
                text-align: center;
                margin: 0 auto;
                background-color: #169bd5;
                color: #fff;
                border-radius: 5px;
                margin-top: 140px;
                cursor: pointer;
            }
            .allcancel{

                width: 35px;
                height: 120px;
                padding: 10px;
                text-align: center;
                margin: 0 auto;
                background-color: #fff;
                color: #169bd5;
                border: 1px solid #169bd5;
                border-radius: 5px;
                margin-top: 50px;
                cursor: pointer;
            }
        }
        .righttablebox{

            width: 45%;
            .operationbtn{

                margin: 20px 0;
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/selects/exportdown.vue